import {
  buildQuestions,
  daysAgo,
  deliveryLine,
  type OfferQuestion,
  type Rfq,
  type Send,
  t,
} from '@procumi/shared';
import { useState } from 'react';
import type { Toast } from '../hooks/useToast';
import { api, errMsg } from '../lib/api';
import { copyText } from '../lib/clipboard';
import { Dialog } from './Dialog';
import { swMail } from '../lib/terms';

const row = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 10,
  flexWrap: 'wrap',
} as const;

/**
 * „De întrebat”: mailul cu ce lipsește din oferta care ar câștiga. Ca la
 * cerere și la follow-up, mailul pleacă din programul omului; aici doar se
 * pregătește și se notează că a plecat. Răspunsul se trece apoi în ofertă.
 */
export function AskDialog({
  rfq,
  send,
  questions,
  signature,
  toast,
  onAsked,
  onClose,
}: {
  rfq: Rfq;
  send: Send;
  questions: OfferQuestion[];
  signature: string;
  toast: Toast;
  onAsked: (updated: Rfq) => void;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const mail = swMail(
    buildQuestions(
      { title: rfq.title, site: deliveryLine(rfq.site) },
      { name: send.supplier.name, contact: send.contact.name },
      questions,
      signature,
    ),
  );

  const asked = async () => {
    setBusy(true);
    try {
      onAsked(await api.asked(rfq.id, send.id));
      onClose();
      toast(t('Notat: l-ai întrebat pe {0}', send.supplier.name));
    } catch (e) {
      toast(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog onClose={onClose}>
      <div className="dlg-h">
        <div>
          <h2>{t('Întrebări pentru {0}', send.supplier.name)}</h2>
          <p className="hint">
            {send.contact.name ? `${send.contact.name} · ` : ''}
            {send.contact.email}
            {send.askedAt ? t(' · ai mai întrebat {0}', daysAgo(send.askedAt)) : ''}
          </p>
        </div>
      </div>
      <div className="dlg-b">
        <p className="hint" style={{ margin: 0 }}>
          {t(
            'Oferta lui iese cea mai ieftină, dar lipsește {0}. Când răspunde, trece răspunsul în ofertă și comparația se reface.',
            questions.map((q) => q.topic).join(' și '),
          )}
        </p>
        <div style={row}>
          <span>
            <b>{t('Subiect:')}</b> {mail.subject}
          </span>
          <button className="btn small" onClick={() => void copyText(mail.subject, toast)}>
            {t('Copiază subiectul')}
          </button>
        </div>
        <div className="mail">{mail.body}</div>
      </div>
      <div className="dlg-f">
        <button className="btn" onClick={onClose}>
          {t('Anulează')}
        </button>
        <button className="btn" onClick={() => void copyText(mail.body, toast)}>
          {t('Copiază textul')}
        </button>
        <button className="btn primary" disabled={busy} onClick={() => void asked()}>
          {t('Am întrebat')}
        </button>
      </div>
    </Dialog>
  );
}
